<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import OrdersList from "@/components/orderslist"
import OffersApi from "@/services/offers-api";
import SuppliersApi from "@/services/suppliers-api";
import CustomersApi from "@/services/customers-api";
import OrdersApi from "@/services/orders-api";
import Swal from "sweetalert2";


/**
 * Orders-list component
 */
export default {
  page: {
    title: "Liste des Commandes ",
    meta: [{ name: "description", content: appConfig.description }]
  },
  mounted(){
    this.role=sessionStorage.getItem("userr");
    if(this.role == 0 || this.role==2){
      this.getSuppliers()
    }

    if(this.role==1 || this.role==2){
      this.getCustomers()
    }

    if(this.role==1 || this.role==2){ 
      this.getOffers();
    }

    this.getIsPreOrderSupported();
  },

  components: { Layout, OrdersList},
  computed: {
    computedOffersListFields() {
      if(sessionStorage.getItem("userr") != 2)
        return this.offersListFields.filter(field => !field.requiresAdmin);
      else
        return this.offersListFields;
    },
  },
  data() {
    return {
      suppliersList:[],
      selected:null,
      selectedSupplier:null,
      role:null,
      selectedState:null,
      status:null,
      ordersStatus:[{name :"Nouvelle",value: 1},{name :"Confirmée", value: 2},{name :"Livrée", value: 3},{name :"Annulée", value: 4}],
      customersList:[],
      selectedCustomer:null,
      selected2:null,
      reference:null,
      selectedReference:null,
    

      isPreOrderSupported : false,
      offersList: [],
      offersListFields: [
        { key:"supplierName", label: "Fournisseur",   sortable: false, tdClass:"align-middle font-weight-bold text-primary", requiresAdmin: true},
        { key:"title", label: "Intitulé de l'Offre",   sortable: false, tdClass:"align-middle font-weight-bold text-primary"},
        { key:"formattedstartDate", label: "Date Début", tdClass:"align-middle" },
        { key:"formattedendDate", label: "Date Fin", tdClass:"align-middle"},
        { key:"formattedPublishDate", label: "Publication", tdClass:"align-middle" },
        { key:"isActive", label: "Etat", tdClass:"align-middle" },
        { key:"actions", label:"", tdClass: "align-middle text-right", thClass: "text-right", thStyle:"width:100px;"}
        ],
        offerPageModelMain: {currentPage : 1, perPage : 5, totalRows: 0},
        isOffersTableBusy: false,

        showPreOrderTransferModel: false,
        consolidatedPreOrderTotalQty: 0,
        consolidatedPreOrder: null,
        preOrderTransferSupplier: null,
    };
  }, 
  methods:{

    selectedReferenceInput(){
      this.selectedReference = this.reference
    },
    
    getSuppliers(){
      SuppliersApi.getAllSuppliers().then(
        response => {
          this.suppliersList=response;
        }
      )
    },

    getIsPreOrderSupported() { 
      SuppliersApi.getIsPreOrderSupported() 
      .then(isPreOrderSupported => {
          this.isPreOrderSupported = isPreOrderSupported;
        })
    },


    getCustomers(){
      CustomersApi.getCustomers().then(
        response => {
          this.customersList=response;
        }
      )
    },

    getOffers(){

      if(this.role == 0) {
        return;
      }

      this.isOffersTableBusy = true;
      OffersApi.getAllOffers(this.offerPageModelMain.currentPage, this.offerPageModelMain.perPage, this.selectedSupplier)
        .then(response => {
          this.offersList = response.list
          this.offerPageModelMain.totalRows = response.total;
          this.offerPageModelMain.currentPage = response.page;
          this.offerPageModelMain.perPage = response.pageSize;
          this.offerPageModelMain.pageSize = response.pageSize;
        })
        .finally(() => {
        this.isOffersTableBusy = false;
      })

    },

    transferPreOrders(promotionId) {

      this.consolidatedPreOrderTotalQty = 0;
      this.consolidatedPreOrder = null;
      this.preOrderTransferSupplier = null;

      this.getSuppliers();

      OrdersApi.getOrder(promotionId * -1)
      .then(order => {
        
        if (!order || !order.lines) {
          return;
        }

        this.consolidatedPreOrderTotalQty = 0;
        for (var i=0; i<order.lines.length; i++) {
            this.consolidatedPreOrderTotalQty += order.lines[i].quantity;
        }
        
        this.consolidatedPreOrder = order;
        this.showPreOrderTransferModel=true;

      })

      .finally(() => {
      })
    },

    confirmTransferPreOrders() {
      
      if (!this.consolidatedPreOrder || !this.preOrderTransferSupplier) {
        return;
      }

      this.showPreOrderTransferModel=false;

      Swal.fire({
        title: "Confirmer ?",
        html: "Transférer '" + this.consolidatedPreOrder.ref  + "' vers <strong>" + this.preOrderTransferSupplier.name + "</strong> ? <span class='text-danger'>Le transfert des précommandes est irréversible !</span>",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Annuler",
        confirmButtonText: "Oui, transférer!"
        }).then(result => {
            if (result.value) {
                OrdersApi.transferPreOrder(this.consolidatedPreOrder.id, this.preOrderTransferSupplier.id)
                .then(() =>{
                  this.$refs['orders-list'].getOrders();
                  this.getOffers();
                  
                }) 
            }
        })
    }


  },
    watch: {
        selected: function() {
            this.selectedSupplier = this.selected ? this.selected.id : null
        },

        selected2: function() {
            this.selectedCustomer = this.selected2 ? this.selected2.id : null
        },

        selectedState: function() {
            this.status = this.selectedState ? this.selectedState.value : null
        },

    }       
    }

</script>

<template>
  <Layout>
   
    <div class="row pt-4 pb-4">
      <div class="col-lg-12">
        <div class="card border border-light">
          <div class="card-body">
            <h2 class="card-title font-size-25" style="font-size:25px;">Liste des Commandes </h2>

                <div  class="row mt-2">
                  <div v-if="role==0"  class="col-sm-4 col-xs-6 pr-2">
                    <b-form-group label="Fournisseur" label-for="">
                      <v-select class="style-vselect" style="font-size:16px;" :options="suppliersList" placeholder="Fournisseur" label="name" v-model="selected">
                        <span slot="no-options">Aucun fournisseur dans la liste</span>
                      </v-select>
                    </b-form-group>
                  </div>
                  <div v-if="role==2"  class="col-sm-4 col-xs-6 pr-2">
                    <b-form-group label="Fournisseur" label-for="">
                      <v-select class="style-vselect" style="font-size:16px;" :options="suppliersList" placeholder="Fournisseur" label="name" v-model="selected">
                        <span slot="no-options">Aucun fournisseur dans la liste</span>
                      </v-select>
                    </b-form-group>
                  </div>
                  <div v-if="role==1" class="col-sm-4 col-xs-6 pr-2">
                    <b-form-group label="Client" label-for="">
                      <v-select class="style-vselect" style="font-size:16px;" :options="customersList" placeholder="Client" label="name" v-model="selected2">
                        <span slot="no-options">Aucun client dans la liste</span>
                      </v-select>
                    </b-form-group>
                  </div>
                  <div v-if="role==2"  class="col-sm-4 col-xs-6 pr-2">
                    <b-form-group label="Client" label-for="">
                      <v-select class="style-vselect" style="font-size:16px;" :options="customersList" placeholder="Client" label="name" v-model="selected2">
                        <span slot="no-options">Aucun client dans la liste</span>
                      </v-select>
                    </b-form-group>
                  </div>
                  <div v-if="role==1 || role==0" class="col-sm-4 col-xs-0"/>
                  <div class="col-sm-4 col-xs-0">
                    <b-form-group label="Etat" label-for="">
                      <v-select class="style-vselect" style="font-size:16px;" :options="ordersStatus" placeholder="Etat" label="name" v-model="selectedState" :searchable="false">
                        <span slot="no-options">Aucun etat dans la liste</span>
                      </v-select>
                    </b-form-group>
                  </div>
                    <div v-if="role==1 || role==2" class="col-sm-4 col-xs-0">
                      <b-form-group>
                            <label for="address" class="pt-1 pb-1 font-size-14 font-weight-bold">Filter par Article</label>
                            <input
                            id="address"
                            placeholder="Rechercher par référence ou désignation de l’article"
                            type="text"
                            class="form-control font-size-13 "
                            v-model="reference"
                            @keyup.enter="selectedReferenceInput()"

                            />
                      </b-form-group>
                    </div>


                </div>
                <OrdersList ref="orders-list" :isAllOrders="true" :reference.sync=this.selectedReference :supplierId.sync=this.selectedSupplier :status.sync=this.status :customerId.sync=this.selectedCustomer />

          </div>
        </div>
      </div>
    </div>

    <div class="row mb-4" v-if="(role==1 && isPreOrderSupported) || role==2">
      <div class="col-lg-12">
        <div class="card border border-light ">
          <div class="card-body">
  
                <h2 class="card-title font-size-25" style="font-size:25px;">Commandes consolidées</h2>
                <p class="card-title-desc font-size-14">
                  Liste des commmandes consolidées par Offre
                </p>

                <div class="table-responsive mt-4" style="min-height:20em">        
                  <b-table 
                  :busy="isOffersTableBusy"
                  :striped="true"

                  :small="false"
                  :hover="true"

                  :items="offersList"
                  :fields="computedOffersListFields"

                  :perPage="offerPageModelMain.perPage"
                  class="table  "
                  >
                  <template v-slot:table-busy>
                  <div class="text-center my-2">
                      <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                  </div>
                  </template>

                  <template v-slot:cell(actions)="{item}">
                    <a v-if="item.linesCount != 0" href="javascript:void(0);" @click="transferPreOrders(item.id)" class="action-icon font-size-16 text-primary mr-4"><i v-b-tooltip.hover title="Transférer les Commandes" class="dripicons-export font-size-24 text-warning"></i></a>

                    <router-link :to="{ path: '/orders/order', query: { orderId: item.id * -1, showCashTotal: true }}">
                      <a v-if="item.linesCount != 0" href="javascript:void(0);"  class="action-icon font-size-16 text-primary"><i v-b-tooltip.hover title="Ouvrir" class="fas fa-file-import font-size-24 text-primary"></i></a>
                  </router-link>
                  </template>

                  <template v-slot:cell(isActive)="{value}">
                   <h5><b-badge href="#" :variant="value ? 'success' : 'secondary'">{{value ? 'Active' : 'Inactive'}}</b-badge></h5>
                  </template>

                  </b-table>
                  <span v-if="!isOffersTableBusy && !offersList.length" class="d-flex justify-content-center m-4 text-danger" >Aucune commande dans la liste</span>
                </div> 
                <!-- Pagination -->
                <div class="row pt-3 mb-sm-4">
                    <div class="col-sm-8">
                        <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                            <b-form-select @input="getOffers()"  v-model="offerPageModelMain.perPage" size="sm" style="width: 60px" :options="[5,10,50,100]"></b-form-select>
                            <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">sur</span><span class="font-weight-bold"> {{offerPageModelMain.totalRows}} lignes</span></div>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="dataTables_paginate paging_simple_numbers float-right">
                            <ul class="pagination pagination-rounded mb-0">
                            <b-pagination v-model="offerPageModelMain.currentPage" :disabled="isOffersTableBusy" :per-page="offerPageModelMain.pageSize" :total-rows="offerPageModelMain.totalRows" @input="getOffers ()" ></b-pagination>
                            </ul>
                        </div>
                    </div>
                </div> 
                    <!-- Fin Pagination  -->  
                
          </div>
        </div>
      </div>
    </div>

    <b-modal
      v-model="showPreOrderTransferModel"
      title="Transfert des Pré-Commandes"
      centered 
      title-class="text-warning d-print-none"
      title-tag="h5"
      no-close-on-backdrop
      header-close-variant="danger d-print-none"
      class="modal-fullscreen"
      
      full-screen
      hide-footer 
      >

      <div class="zoom-container">
        <div class="row">
            <div class="col-12 text-left">
              <span class="font-weight-bold text-primary font-size-16">{{!this.consolidatedPreOrder ? '' : this.consolidatedPreOrder.ref}}</span>
            </div>

              <!-- <div class="col-6 font-size-14 text-right">
                
              </div> -->
        </div>

        <div class="row mt-4 bg-light">
            <div class="col-6 text-left">
              <span class="font-weight-bold font-size-14">Articles Panachables</span>
            </div>

            <div class="col-6 font-size-14 text-right">
              {{this.consolidatedPreOrderTotalQty}}
            </div>
        </div>

        <div class="row mt-2 bg-light">
            <div class="col-6 text-left">
              <span class="font-weight-bold font-size-14">Nombre de lignes</span>
            </div>

            <div class="col-6 font-size-14 text-right">
              {{!this.consolidatedPreOrder ? '' : this.consolidatedPreOrder.lines.length}}
            </div>
        </div>

        <div class="row mt-2 bg-light">
            <div class="col-6 text-left">
              <span class="font-weight-bold font-size-14">Total Remise</span>
            </div>

            <div class="col-6 font-size-14 text-right">
              {{!this.consolidatedPreOrder ? '' : this.consolidatedPreOrder.discountAmount}} TND
            </div>
        </div>

        <div class="row mt-2 bg-light">
            <div class="col-6 text-left">
              <span class="font-weight-bold font-size-14">Total HT</span>
            </div>

            <div class="col-6 font-size-14 text-right">
              {{!this.consolidatedPreOrder ? '' : this.consolidatedPreOrder.total}} TND
            </div>
        </div>

        <div class="row mt-2 mb-4 bg-light">
            <div class="col-6 text-left">
              <span class="font-weight-bold font-size-14">Total TTC</span>
            </div>

            <div class="col-6 font-size-14 text-right">
              {{!this.consolidatedPreOrder ? '' : this.consolidatedPreOrder.totalWithTaxes}} TND
            </div>
        </div>

        <hr/>

        <div class="row mt-2">
          <div class="col-12">
            <b-form-group>
                <label  class="pt-1 pb-1 font-size-16 text-primary font-weight-bold">Transférer vers un fournisseur</label>

                <v-select class="style-vselect" style="font-size:1em;" :options="suppliersList" v-model="preOrderTransferSupplier" placeholder="" label="name" >
                    <span slot="no-options">Aucun élément dans la liste</span>
                </v-select>   
            </b-form-group>

          </div>

          <div class="col-12">
           

            <b-button @click.prevent="confirmTransferPreOrders()" class="h-100 w-100" variant="primary" title="Tranférer la précommande" >
              <span class="font-size-16 font-weight-bold"><i class="dripicons-export font-size-18 align-middle "></i> Transférer {{!this.preOrderTransferSupplier ? '' : 'vers ' + this.preOrderTransferSupplier.name}}</span>
            </b-button> 

          </div>
        </div>
      </div>
    </b-modal>

  </Layout>
</template>